<div class="local-python-scripts-editor-container">
    <div class="header-container">
        <label>{{ title }}</label>
        <smart-icon name="close" (click)="onSlideSheetClose()" class="light"></smart-icon>
    </div>
    <div class="input-container">
        <div class="tam-form-field">
            <label class="required">ID</label>
            <input [(ngModel)]="localPythonScript.id" class="tam-input tam-textbox" type="text"
                value="localPythonScript.id" [readonly]="true" [class.disabled]="true">
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error':name.invalid}">
            <label class="required">Name</label>
            <input [(ngModel)]="localPythonScript.name" class="tam-input tam-textbox" type="text"
                value="localPythonScript.name" [formControl]="name">
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error': script.invalid}">
            <label class="required">Python Code</label>
            <textarea class="tam-textbox textarea" [(ngModel)]="localPythonScript.script"
                value="localPythonScript.script" [formControl]="script"></textarea>
            <div class="tam-form-help" *ngIf="script.invalid && script.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
    </div>
    <div class="button-container">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
            {{'general.submit' | stringLiterals}}
        </button>
        <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" class="button" (click)="onSlideSheetClose()">
            {{'general.cancel' | stringLiterals}}
        </button>
    </div>
</div>